export default __webpack_public_path__ + "static/media/person4.45fff754.svg";